document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.Swiper === 'undefined') return;

  const galleryNodes = document.querySelectorAll('.collection-swiper');

  galleryNodes.forEach((galleryNode) => {
    if (galleryNode.dataset.swiperInitialized === 'true') return;

    const paginationNode = galleryNode.querySelector('.collection-swiper-pagination');

    galleryNode.dataset.swiperInitialized = 'true';

    new Swiper(galleryNode, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      simulateTouch: true,
      grabCursor: true,
      allowTouchMove: true,
      speed: 300,
      threshold: 5,
      preventClicks: true,
      preventClicksPropagation: true,
      pagination: paginationNode
        ? {
            el: paginationNode,
            clickable: true,
            type: 'bullets',
          }
        : undefined,
    });
  });
}); 